import {defineStore} from 'pinia'
import api from '@/services/api'
import {useUserStore} from '@/stores/user'
import {useItemDataStore} from '@/stores/itemData'

export const useAssumeUserStore = defineStore('assumeUser', {
    state: () => ({
        assumedByCacheKey: 'userAssumedBy',
    }),
    
    actions: {
        assume(userId) {
            const userStore = useUserStore()
            
            const currentUserId = userStore.user?.id
            if (currentUserId) {
                localStorage.setItem(this.assumedByCacheKey, currentUserId)
            }
            
            this._setUser(userId)
        },
        
        async unassume() {
            console.error('Unassume is not currently in use.')
            
            /*
            let userId = localStorage.getItem(this.assumedByCacheKey)
      
            await api.get(`api/user/${userId}/token`)
            await this._setUser(userId)
            localStorage.removeItem(this.assumedByCacheKey)
            */
        },
        
        // Requests the userId's user item, JWT token and access data.
        async _setUser(userId) {
            const userStore = useUserStore()
            const itemDataStore = useItemDataStore()
            
            let user = await itemDataStore.get({
                tableName: 'users',
                id: userId,
            })
            
            const tokenObj = await api.get(`api/user/${userId}/token`)
            if (tokenObj.data?.token) {
                localStorage.setItem('token', tokenObj.data.token)
            }
            
            const accessObj = await api.get(`api/user/${userId}/access`)
            user.access = accessObj.data
            
            await userStore.set(user)
            window.location.href = '/'
        },
    },
})